export function updateUserAddress(address) {
    return {
      type: 'UPDATE_USER_ADDRESS',
      address
    };
  }
